export class UserOffline {
    public static readonly type = '[MessagingState] User offline';

    constructor(public uuid: string) {}
}
